export default __webpack_public_path__ + "static/media/ledger.a1108715.svg";